import angular from "angular";

angular.module('api-common', []);
